import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b5f1e4f4")

_pushScopeId("data-v-b5f1e4f4")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "invited" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "box-body" }
const _hoisted_7 = { class: "data-row-inline" }
const _hoisted_8 = { class: "data-row-inline" }
const _hoisted_9 = { class: "data-row-inline" }
const _hoisted_10 = { class: "data-row-inline room-status" }
const _hoisted_11 = {
  key: 0,
  class: "box-spinner"
}
const _hoisted_12 = { class: "box" }
const _hoisted_13 = { class: "box-body" }
const _hoisted_14 = { class: "data-row" }
const _hoisted_15 = { class: "data-row" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = { class: "box-footer" }
const _hoisted_18 = {
  key: 0,
  class: "box-spinner"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")
  const _component_Alert = _resolveComponent("Alert")
  const _directive_scrollIcon = _resolveDirective("scrollIcon")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", null, _toDisplayString(_ctx.t('invited-title')), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("label", null, _toDisplayString(_ctx.t('inviter')), 1),
              _createVNode("span", null, _toDisplayString(_ctx.state.inviter), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("label", null, _toDisplayString(_ctx.t('room name')), 1),
              _createVNode("span", null, _toDisplayString(_ctx.state.roomName), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("label", null, _toDisplayString(_ctx.t('expire date')), 1),
              _createVNode("span", null, _toDisplayString(_ctx.state.expireDate), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", null, _toDisplayString(_ctx.t('room status')), 1),
              _createVNode("span", null, _toDisplayString(_ctx.roomStatus), 1)
            ])
          ]),
          (_ctx.isFetchingInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_ProgressSpinner)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Form, { onSubmit: _ctx.joinVideoChat }, {
          default: _withId(({ errors }) => [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("label", null, _toDisplayString(_ctx.t('participant')), 1),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.participant,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.participant = $event)),
                    name: "participant",
                    rules: "required"
                  }, {
                    default: _withId(({ field }) => [
                      _createVNode(_component_InputText, _mergeProps({
                        id: "participant",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => (field.value = $event),
                        class: { 'p-invalid': errors.password }
                      }, field, { type: "text" }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "password",
                    class: "p-error"
                  })
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("label", null, _toDisplayString(_ctx.t('password')), 1),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                    name: "password",
                    rules: "required"
                  }, {
                    default: _withId(({ field }) => [
                      _createVNode(_component_InputText, _mergeProps({
                        id: "password",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => (field.value = $event),
                        class: { 'p-invalid': errors.password }
                      }, field, { type: "password" }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "password",
                    class: "p-error"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("span", null, _toDisplayString(_ctx.t('invited-info')), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_Button, {
                  type: "submit",
                  class: "-button -medium -royalBlue p-button-primary",
                  disabled: !_ctx.isRoomJoinable
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('join chat')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              (_ctx.isFetchingJoin)
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    _createVNode(_component_ProgressSpinner)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            isConfirm: true,
            "onUpdate:clear": _cache[3] || (_cache[3] = 
          () => {
            _ctx.alert.content = '';
          }
        )
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_directive_scrollIcon]
  ])
})